document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll(".pp_inside_trigger__js");
  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      const parent = trigger.closest(".step-box");
      if (!parent) return;
      const content = parent.querySelector(".pp_hydro_inside_text");
      if (content.style.display === "block") {
        content.style.display = "none";
        trigger.classList.remove("rotated");
      } else {
        content.style.display = "block";
        trigger.classList.add("rotated");
      }
    });
  });
  
  let faqItem = document.querySelectorAll(".faq-item");

  faqItem.forEach(item => {
      item.addEventListener("click", () => {
          faqItem.forEach(i => {
              if (i !== item) i.classList.remove("open");
          });
          item.classList.toggle("open");
      });
  });

});

const variantEvent = document.querySelectorAll(".variant-added");
variantEvent.forEach((item) => {
  item.addEventListener("click", function (e) {
    e.preventDefault();
    setTimeout(() => {
      document.querySelector("#cart-link")?.click();
    }, 2500);
  });
});

document.addEventListener("DOMContentLoaded", function () {
    let productContainer = document.querySelector(".product__info-container");
    let targetSections = document.querySelectorAll(".shopify-section.tabs");
    if (productContainer && targetSections.length > 0) {
        let proAccordian = document.querySelectorAll(".product__accordion");
        
        proAccordian.forEach((item, index) => {
            if (index === 1) { 
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if(targetSections[1]) {
                        targetSections[1].scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                });
            }
            else if (index === 2) {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if(targetSections[0]) {
                        targetSections[0].scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                });
            }
        });
    }
});
